export const AdminFeatures = {
    USER_MANAGEMENT: 'userManagement',
    BLOG_MANAGEMENT: 'blogManagement',
    REPORTING: 'reporting',
    ANALYTICS: 'analytics',
    SETTINGS: 'settings'
}